import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DragDropService {
  constructor() {}

  // This method is not currently in use and is not called anywhere else.
  // scanFilesAndFolder(item, container, isDrag) {
  //   var elem = document.createElement('li');
  //   elem.textContent = item.name;
  //   container.appendChild(elem);

  //   isDrag = false;

  //   if (item.isDirectory) {
  //     var directoryReader = item.createReader();
  //     var directoryContainer = document.createElement('ul');
  //     container.appendChild(directoryContainer);

  //     directoryReader.readEntries((entries) => {
  //       entries.forEach((entry) => {
  //         this.scanFilesAndFolder(entry, directoryContainer, isDrag);
  //       });
  //     });
  //   }
  // }

  parsePathArray(formList) {
    let tree = [];
    for (let i = 0; i < formList.length; i++) {
      let path = formList[i].fullPath.split('/').slice(1);
      let type = formList[i].type;
      let size = formList[i].size;
      let originalFile = formList[i].originalFile;
      let uniquesKey = formList[i]?.uniquesKey;
      let currentLevel = tree;

      for (let j = 0; j < path.length; j++) {
        let part = path[j];
        let existingPath = this.findWhere(currentLevel, 'name', part);

        if (existingPath) {
          currentLevel = existingPath.children;
        } else {
          let newPart = {
            name: part,
            children: [],
            data: formList[i],
            type: type,
            size: size,
            uniquesKey: uniquesKey,
            originalFile: originalFile,
          };
          currentLevel.push(newPart);
          currentLevel = newPart.children;
        }
      }
    }

    return tree;
  }

  findWhere(array, key, value) {
    // count is used as a counter
    let count = 0;
    while (count < array.length && array[count][key] !== value) {
      count++;
    }
    // find the index where the id is the as the aValue
    if (count < array.length) {
      return array[count];
    } else {
      return false;
    }
  }

  getSize(bytes, decimals) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
